
//メインメニューオープン
$(function () {
    $("#nav-drawer,.overlay").on("click", function () {
      if ($("#nav-drawer").hasClass("open")) {
        $("#nav-drawer,.mainmenu-area,ul.header-othermenu,.header-othermenu-sp").removeClass("open");
        $(".overlay").css("display", "none");
      } else {
        $("#nav-drawer,.mainmenu-area,ul.header-othermenu,.header-othermenu-sp").addClass("open");
        $(".overlay").css("display", "block");
      }
    });
});

//メインメニュー:メニューのトグル開閉
document.addEventListener('DOMContentLoaded', function () {
  const buttons = document.querySelectorAll('.grandchild-open-btn');

  buttons.forEach(function(button) {
      button.addEventListener('click', function() {
          const grandchildOpen = this.parentElement;
          const grandchildMenu = grandchildOpen.nextElementSibling;

          // activeクラスの切り替え
          grandchildOpen.classList.toggle('active');

          // 高さが0かどうかで開閉状態を判断
          if (grandchildMenu.style.height) {
              grandchildMenu.style.height = null;
          } else {
              grandchildMenu.style.height = grandchildMenu.scrollHeight + "px";
          }

          // クラスを切り替えることでCSS側での処理を利用
          grandchildMenu.classList.toggle('open');
      });
  });
});




//ブログ検索オープン
$(function () {
  $(".blog-sertch-btn,.overlay-search").on("click", function () {
    if ($(".blog-search").hasClass("open")) {
      $(".blog-search").removeClass("open");
      $(".overlay-search").removeClass("open");
    } else {
      $(".blog-search").addClass("open");
      $(".overlay-search").addClass("open");
    }
  });
});

//ブログカテゴリオープン
$(function () {
  $(".blog-category-btn").on("click", function () {
    if ($(".blog-categorymenu").hasClass("active")) {
      $(".blog-categorymenu,.blog-category-btn").removeClass("active");
    } else {
      $(".blog-categorymenu,.blog-category-btn").addClass("active");
    }
  });
});

// $(function(){
//   var toplogo=$('#gotoplogo');
//   toplogo.hide();
 
//  $(window).scroll(function(){
//    if($(this).scrollTop()>250){
 
//     toplogo.fadeIn();
 
//    }else{
//     toplogo.fadeOut();
 
//    } 
//   }); 
//  });